import React from 'react';

const PageNav = ({ Heading, PageSvg }) => {
    //   const theme = JSON.parse(localStorage.getItem('schoolInfo')).theme
// bg-blue-100 
    return (
        <div className='bg-blue-100 flex border-0 justify-between rounded-lg mt-8 sm:mt-8 px-6 py-4 items-center shadow-lg'>
            <div className='' >
                <Heading />
            </div>
            <PageSvg />
        </div>
    )
}

export default PageNav;